import type { Template } from "@/types";


export const LA_07_H7_V0: Template[] = [
    {
        id: "la-07-h7v0-01",
        name: "LA 01 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h7_v0_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 78, y: 77, width: 256, height: 162, rotation: 0, imageRotation: 0 },
            { id: "2", x: 78, y: 246, width: 256, height: 161, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 77, width: 256, height: 162, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 246, width: 256, height: 161, rotation: 0, imageRotation: 0 },
            { id: "5", x: 812, y: 46, width: 198, height: 127, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1017, y: 46, width: 198, height: 127, rotation: 0, imageRotation: 0 },
            { id: "7", x: 812, y: 180, width: 403, height: 259, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-02",
        name: "LA 02 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h7_v0_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 39, y: 52, width: 600, height: 380, rotation: 0, imageRotation: 0 },
            { id: "2", x: 816, y: 52, width: 195, height: 122, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1018, y: 52, width: 194, height: 122, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 181, width: 195, height: 122, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 181, width: 194, height: 122, rotation: 0, imageRotation: 0 },
            { id: "6", x: 816, y: 311, width: 195, height: 121, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 311, width: 194, height: 121, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-03",
        name: "LA 03 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h7_v0_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 93, y: 48, width: 487, height: 274, rotation: 0, imageRotation: 0 },
            { id: "2", x: 93, y: 329, width: 157, height: 107, rotation: 0, imageRotation: 0 },
            { id: "3", x: 258, y: 329, width: 157, height: 107, rotation: 0, imageRotation: 0 },
            { id: "4", x: 423, y: 329, width: 157, height: 107, rotation: 0, imageRotation: 0 },
            { id: "5", x: 774, y: 48, width: 486, height: 238, rotation: 0, imageRotation: 0 },
            { id: "6", x: 774, y: 293, width: 239, height: 142, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1021, y: 293, width: 239, height: 142, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-04",
        name: "LA 04 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h7_v0_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 56, y: 63, width: 565, height: 357, rotation: 0, imageRotation: 0 },
            { id: "2", x: 732, y: 63, width: 184, height: 115, rotation: 0, imageRotation: 0 },
            { id: "3", x: 732, y: 185, width: 184, height: 114, rotation: 0, imageRotation: 0 },
            { id: "4", x: 732, y: 306, width: 184, height: 114, rotation: 0, imageRotation: 0 },
            { id: "5", x: 923, y: 63, width: 184, height: 115, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1114, y: 63, width: 183, height: 115, rotation: 0, imageRotation: 0 },
            { id: "7", x: 923, y: 185, width: 374, height: 235, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-05",
        name: "LA 05 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h7_v0_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 244, y: 49, width: 283, height: 189, rotation: 0, imageRotation: 0 },
            { id: "2", x: 535, y: 49, width: 283, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 825, y: 49, width: 283, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 100, y: 245, width: 283, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 390, y: 245, width: 282, height: 189, rotation: 0, imageRotation: 0 },
            { id: "6", x: 680, y: 245, width: 282, height: 189, rotation: 0, imageRotation: 0 },
            { id: "7", x: 969, y: 245, width: 282, height: 189, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-06",
        name: "LA 06 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h7_v0_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 108, y: 35, width: 278, height: 174, rotation: 0, imageRotation: 0 },
            { id: "2", x: 394, y: 35, width: 278, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 35, width: 278, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 965, y: 35, width: 278, height: 174, rotation: 0, imageRotation: 0 },
            { id: "5", x: 108, y: 216, width: 373, height: 233, rotation: 0, imageRotation: 0 },
            { id: "6", x: 489, y: 216, width: 373, height: 233, rotation: 0, imageRotation: 0 },
            { id: "7", x: 870, y: 216, width: 373, height: 233, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-07",
        name: "LA 07 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h7_v0_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 50, y: 40, width: 203, height: 129, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 177, width: 203, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 50, y: 313, width: 203, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 260, y: 313, width: 203, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 260, y: 40, width: 413, height: 266, rotation: 0, imageRotation: 0 },
            { id: "6", x: 470, y: 313, width: 203, height: 129, rotation: 0, imageRotation: 0 },
            { id: "7", x: 681, y: 40, width: 622, height: 402, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-08",
        name: "LA 08 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h7_v0_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 50, y: 40, width: 623, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 681, y: 40, width: 203, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 681, y: 177, width: 203, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 313, width: 203, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 891, y: 40, width: 412, height: 266, rotation: 0, imageRotation: 0 },
            { id: "6", x: 891, y: 313, width: 203, height: 129, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1101, y: 313, width: 202, height: 129, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-09",
        name: "LA 09 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h7_v0_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 71, y: 69, width: 354, height: 228, rotation: 0, imageRotation: 0 },
            { id: "2", x: 71, y: 304, width: 173, height: 110, rotation: 0, imageRotation: 0 },
            { id: "3", x: 252, y: 304, width: 173, height: 110, rotation: 0, imageRotation: 0 },
            { id: "4", x: 433, y: 69, width: 173, height: 110, rotation: 0, imageRotation: 0 },
            { id: "5", x: 433, y: 187, width: 173, height: 110, rotation: 0, imageRotation: 0 },
            { id: "6", x: 433, y: 304, width: 173, height: 110, rotation: 0, imageRotation: 0 },
            { id: "7", x: 676, y: 0, width: 676, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-10",
        name: "LA 10 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h7_v0_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 676, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 747, y: 304, width: 173, height: 110, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1109, y: 69, width: 173, height: 110, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1109, y: 187, width: 173, height: 110, rotation: 0, imageRotation: 0 },
            { id: "5", x: 747, y: 69, width: 354, height: 228, rotation: 0, imageRotation: 0 },
            { id: "6", x: 928, y: 304, width: 173, height: 110, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1109, y: 304, width: 173, height: 110, rotation: 0, imageRotation: 0 }
        ],
    }
];